import { render, staticRenderFns } from "./PagibigContributionDetails.vue?vue&type=template&id=f2390aa4&scoped=true"
import script from "./PagibigContributionDetails.vue?vue&type=script&lang=js"
export * from "./PagibigContributionDetails.vue?vue&type=script&lang=js"
import style0 from "./PagibigContributionDetails.vue?vue&type=style&index=0&id=f2390aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2390aa4",
  null
  
)

export default component.exports